import { CalendarIcon } from "@primer/octicons-react";
import { Box, Label } from "@primer/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { phuHuynhApi } from "../../../api/phuHuynhApi";

interface DangKyHistoryItem {
    id: number;
    ten_chien_dich: string;
    ma_chien_dich: string;
    register_date: string;
    ho_ten_hoc_sinh: string;
    khoi_lop: string;
    ghi_chu: string;
    ngay_chien_dich?: string;
    dia_diem?: string;
}

interface CSKHDangKyHistoryProps {
    ts_phuhuynh_id: number;
}


const CSKHDangKyHistory: React.FC<CSKHDangKyHistoryProps> = ({ ts_phuhuynh_id }) => {
    const [dataSource, setDataSource] = useState<DangKyHistoryItem[]>([]);

    useEffect(() => {
        handleReload();
    }, [ts_phuhuynh_id]);

    const handleReload = async (): Promise<void> => {
        const res = await phuHuynhApi.selectLichSuDangKy(ts_phuhuynh_id);
        if (res.is_success) {
            setDataSource(res.data);
        }
    };

    if (dataSource.length === 0) {
        return (
            <Box sx={{
                py: 5, textAlign: "center", color: "fg.muted", fontSize: 1,
                border: "1px dashed", borderColor: "border.muted", borderRadius: 2,
            }}>
                Chưa tham gia chiến dịch nào.
            </Box>
        );
    }

    return (
        <Box sx={{ display: "grid", gap: 3 }}>
            {dataSource.map(x => (
                <Box key={x.id} sx={{ border: "1px solid", borderColor: "border.default", borderRadius: 2, overflow: "hidden" }}>
                    <Box sx={{
                        px: 3, py: 2, bg: "canvas.subtle",
                        borderBottom: "1px solid", borderColor: "border.muted",
                        display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap",
                    }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap", minWidth: 0 }}>
                            <Box sx={{ fontWeight: "bold", fontSize: 1 }}>{x.ten_chien_dich?.trim()}</Box>
                            {x.ma_chien_dich && <Label variant="secondary">{x.ma_chien_dich}</Label>}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 0, color: "fg.muted", whiteSpace: "nowrap" }}>
                            <CalendarIcon />
                            Ngày đăng ký: <strong>{moment(x.register_date).format("DD/MM/YYYY")}</strong>
                        </Box>
                    </Box>

                    {/* Chi tiết chiến dịch: thời gian, địa điểm; thêm học sinh / ghi chú nếu có, bỏ dòng trống */}
                    <Box sx={{
                        px: 3, py: 2, fontSize: 1,
                        display: "grid", gridTemplateColumns: ["1fr", "120px 1fr"], gap: 2, alignItems: "baseline",
                    }}>
                        {[
                            { label: "Thời gian", value: x.ngay_chien_dich },
                            { label: "Địa điểm", value: x.dia_diem },
                            { label: "Học sinh", value: [x.ho_ten_hoc_sinh, x.khoi_lop].filter(Boolean).join(" · ") },
                            { label: "Ghi chú", value: x.ghi_chu },
                        ].filter(r => !!r.value?.trim()).map(r => (
                            <React.Fragment key={r.label}>
                                <Box sx={{ color: "fg.muted", fontSize: 0 }}>{r.label}</Box>
                                <Box sx={{ whiteSpace: "pre-wrap" }}>{r.value}</Box>
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default CSKHDangKyHistory;
